let getAccessTokenSilently: Function;

export const security = {
  getAccessTokenSilently: () => getAccessTokenSilently,
  setAccessTokenSilently: (func: Function) => (getAccessTokenSilently = func),
};
